<template>
  <v-app
    :style="{
      'font-family': (siteConfig && siteConfig.navBottomBorderColor === 'orange')
        ? '\'Open Sans\', sans-serif'
        : 'myriad-pro, sans-serif'
    }"
  >
    <router-view />
  </v-app>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'
import googleTagManager from '@analytics/google-tag-manager'

export default {
  name: 'App',
  metaInfo () {
    return {
      titleTemplate: this.titleTemplate
    }
  },
  computed: {
    ...mapState({ siteConfig: state => state.site.siteConfig }),
    titleTemplate () {
      if (!this.siteConfig || (this.siteConfig && !this.siteConfig.careNetworkName)) {
        return '%s'
      }
      return '%s'
    }
  },
  watch: {
    siteConfig () {
      if (!this.siteConfig) {
        return
      }
      const plugins = []
      if (this.siteConfig.gaTrackingId) {
        plugins.push(googleAnalytics({
          trackingId: this.siteConfig.gaTrackingId
        }))
      }
      if (this.siteConfig.gaContainerId) {
        plugins.push(googleTagManager({
          containerId: this.siteConfig.gaContainerId
        }))
      }
      const analytics = Analytics({
        app: 'covantage-web',
        plugins: plugins
      })
      if (this.siteConfig.crossDomainUrls) {
        setTimeout(() => {
          // Allows for cross domain linking for google analytics
          window.ga('require', 'linker')
          window.ga('linker:autoLink', this.siteConfig.crossDomainUrls)
        }, 500)
      }
      Vue.prototype.$analytics = analytics
    },
    $route (to, from) {
      // Call analytics on page changes
      this.$nextTick(() => {
        if (this.$analytics) {
          this.$analytics.page()
        }
      })
    }
  }
}
</script>
